/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TTLOState
 */
export interface TTLOState {
    /**
     * 
     * @type {string}
     * @memberof TTLOState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TTLOState
     */
    disabled?: boolean;
}

export function TTLOStateFromJSON(json: any): TTLOState {
    return TTLOStateFromJSONTyped(json, false);
}

export function TTLOStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLOState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function TTLOStateToJSON(value?: TTLOState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


